<template>
  <footer class="w-full bg-white dark:bg-stone-800 border-t border-stone-200 dark:border-stone-700 mt-8">
    <div class="max-w-7xl mx-auto px-4 py-6">
      <div class="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">

        <!-- Logo and Brand Section -->
        <router-link to="/" class="flex items-center group transition-colors cursor-pointer">
          <img src="/images/favicon-32x32.png" class="inline-block mr-3 transition-opacity group-hover:opacity-80" alt="Spin the Names Logo" />
          <span class="font-cutedino text-xl text-stone-800 dark:text-stone-100 group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors">Spin the Names!</span>
        </router-link>

        <!-- Navigation Links -->
        <div class="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-6">
          <!-- Always visible links -->
          <router-link to="/about" class="footer-link flex items-center">
            <i class="fa fa-info-circle fa-fw mr-2"></i>
            About
          </router-link>

          <router-link to="/blog" class="footer-link flex items-center">
            <i class="fa fa-newspaper fa-fw mr-2"></i>
            Blog
          </router-link>

          <router-link to="/faq" class="footer-link flex items-center">
            <i class="fas fa-question-circle fa-fw mr-2"></i>
            {{ t('toolbar.FAQ') }}
          </router-link>

          <router-link to="/terms-of-service" class="footer-link flex items-center">
            <i class="fas fa-balance-scale fa-fw mr-2"></i>
            {{ t('appInfo.Terms of service') }}
          </router-link>

          <router-link to="/privacy-policy" class="footer-link flex items-center">
            <i class="fas fa-user-secret fa-fw mr-2"></i>
            {{ t('common.Privacy policy') }}
          </router-link>

          <!-- Admin-only links -->
          <template v-if="isAdmin">
            <div class="hidden md:block w-px h-4 bg-stone-300 dark:bg-stone-600"></div>

            <router-link to="/admin" class="footer-link flex items-center">
              <i class="fas fa-user-shield fa-fw mr-2"></i>
              Admin
            </router-link>

            <router-link to="/carousel" class="footer-link flex items-center">
              <i class="fas fa-images fa-fw mr-2"></i>
              Carousels
            </router-link>
          </template>
        </div>
      </div>

      <!-- Mobile admin links separator -->
      <div v-if="isAdmin" class="md:hidden border-t border-stone-200 dark:border-stone-700 mt-4 pt-4">
        <div class="flex flex-col space-y-2">
          <router-link to="/admin" class="footer-link flex items-center">
            <i class="fas fa-user-shield fa-fw mr-2"></i>
            Admin
          </router-link>

          <router-link to="/carousel" class="footer-link flex items-center">
            <i class="fas fa-images fa-fw mr-2"></i>
            Carousels
          </router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAdminStore } from '@/stores/useAdminStore';
import { Auth } from '@services/firebase';

const { t } = useI18n();
const adminStore = useAdminStore();

const isAdmin = computed(() => adminStore.isAdmin);

let authStateUnsubscribe = null;

onMounted(() => {
  adminStore.checkAdminStatus();
  authStateUnsubscribe = Auth.addAuthStateListener((user) => {
    if (user && !user.isAnonymous) {
      adminStore.checkAdminStatus();
    } else {
      adminStore.clearAdminStatus();
    }
  });
});

onBeforeUnmount(() => {
  if (authStateUnsubscribe) {
    authStateUnsubscribe();
    authStateUnsubscribe = null;
  }
});
</script>

<style scoped>
.footer-link {
  @apply text-stone-600 dark:text-stone-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors text-sm;
}

.footer-link:hover {
  @apply no-underline;
}
</style>
